<!-- gap / padding top -->
<section
  class="flex flex-col md2:flex-row items-center justify-between md2:items-start
  md2:gap-[36px] lg:gap-[80px] xl:gap-[96px] w-[100%]
  l-layout__sides
  pt-[64px] sm:pt-[96px] md:pt-[96px] md2:pt-[32px] lg:pt-[48px] xl:pt-[64px]
  min-h-[686px] sm:min-h-[800px] md:min-h-[872px] md2:min-h-[506px] lg:min-h-[550px] xl:min-h-[722px] mx-h-[100vh]"
>
<!-- description width / padding top -->
  <div
    class="md2:flex md2:items-center
    w-[266px] sm:w-[328px] md:w-[356px] md2:w-[428px] lg:w-[440px] xl:w-[578px]
    md2:h-[324px] lg:h-[342px] xl:h-[448px]"
  >
    <slot name="description" />
  </div>
  <!-- image width / margin / container height for mobile -->
  <div
    class="flex items-center md2:block overflow-hidden
    w-[266px] md:w-[330px] md2:w-[324px] md3:w-[362px] lg:w-[371px] xl:w-[442px]
    md2:mx-[46px] lg:mx-[50px] xl:mx-[64px] pointer-events-none
    h-auto xl:mt-auto"
  >
    <slot name="illustration" />
  </div>
</section>
